import React, {FC, useEffect, useState} from 'react'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import {useSelector} from 'react-redux'
import {select_jobIdToCopy} from 'redux/jobs/selectors'
import {useAppDispatch} from 'redux/config'
import {fetchJobDetails, jobsAC} from 'redux/jobs/jobs.duck'

import {CellPropsType} from './cellPropsType'

import {
  Icon,
  Link,
  Tooltip,
} from '@mdsol/onex-design'

import './jobId.scss'

const JobIdCell: FC<CellPropsType> = ({cell}) => {
  const jobId = cell.getValue()
  const dispatch = useAppDispatch()

  const jobIdToCopy = useSelector(select_jobIdToCopy)

  const [copied, setCopied] = useState(false)

  const displayRowDetails = () => {
    if (jobIdToCopy === jobId) {
      dispatch(jobsAC.toggleJobDetails())
      dispatch(jobsAC.jobIdToCopyApplied(''))
    } else {
      dispatch(fetchJobDetails(jobId))
      dispatch(jobsAC.showJobDetails())
      dispatch(jobsAC.jobIdToCopyApplied(jobId))
    }
  }

  const handleCopy = () => {
    setCopied(true)
  }

  useEffect(() => {
    let timeoutCopy

    if(copied) {
      timeoutCopy = setTimeout(() => {
        setCopied(false)
      }, 1000)
      dispatch(jobsAC.jobIdCopiedTimerApplied(timeoutCopy))
    }

    return () => {
      clearTimeout(timeoutCopy)
    }
  }, [copied ,dispatch])

  return (
    <>
      <Link
        key={`link-job-details-${jobId}`}
        dataTestId='job-details-link'
        variant='secondary'
        onClick={displayRowDetails}
      >
        {jobId}
      </Link>

      <div data-testid='copy-container' className='copy-container'>
        {!copied && <CopyToClipboard
          onCopy={handleCopy}
          text={jobId}
        >
          <Icon data-testid='copy-icon'>content_copy</Icon>
        </CopyToClipboard>}

        {copied && <Tooltip
          dataTestId='tooltip-job-id-copied'
          id={`tooltip-job-id-copied--${jobId}`}
          show={copied}
          placement='top-start'
          tooltipChildren='Copied!'
        >
          <Icon className='icon-copied'>check</Icon>
        </Tooltip>
        }

      </div>
    </>
  )
}

export default JobIdCell
